enum ZipInModalEnum {
	zipIn = 'zipIn'
}
export default ZipInModalEnum;
